import React, { useState, useEffect } from "react";
import { fetchData } from "../../../../utils/functions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import NoData, { hasData } from "../../../common/NoData";
import DashboardBarChart from "../../../common/DashboardBarChart";

const EMPTY_STATS = {
  overall: { vaccinated: 0, notVaccinated: 0, total: 0 },
  male: { vaccinated: 0, notVaccinated: 0, total: 0 },
  female: { vaccinated: 0, notVaccinated: 0, total: 0 },
  age0to2: { vaccinated: 0, notVaccinated: 0, total: 0 },
  age3: { vaccinated: 0, notVaccinated: 0, total: 0 },
  age4: { vaccinated: 0, notVaccinated: 0, total: 0 },
};

const CATEGORIES = ["Age 4", "Age 3", "Age 0-2", "Female", "Male", "Overall"];
const KEYS = ["age4", "age3", "age0to2", "female", "male", "overall"];

const VaccinationSection = ({ filters }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [stats, setStats] = useState(EMPTY_STATS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const res = await fetchData(
          "vaccination-statistics",
          "GET",
          null,
          {},
          filters,
          navigate,
          "/vaccination-statistics",
          dispatch
        );
        setStats(res?.data || EMPTY_STATS);
      } catch (err) {
        console.error("Error loading vaccination statistics:", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [filters, navigate, dispatch]);

  const series = [
    { name: "Fully Vaccinated", data: KEYS.map((k) => stats[k]?.vaccinated || 0) },
    { name: "Never Vaccinated", data: KEYS.map((k) => stats[k]?.notVaccinated || 0) },
  ];

  return (
    <div className="bg-white flex flex-col h-full">
      <h3 className="text-xl text-center text-[#3A3A3A] font-bold uppercase text-balance">
        Vaccination Statistics
      </h3>
      <p className="text-center text-sm text-gray-600 mb-4">
        Mandatory Vaccinations for Children Below Age 5
      </p>
      {!loading && !hasData(series.map((s) => s.data)) ? (
        <NoData />
      ) : (
        <DashboardBarChart
          horizontal
          categories={CATEGORIES}
          series={series}
          unit="children"
        />
      )}
    </div>
  );
};

export default VaccinationSection;
